<template src="./burger.html"></template>
<style scoped src="./burger.css"></style>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {}
  },
  methods: {
    toggle () {
      this.$store.commit('toggleSidebar')
    }
  },
  computed: {
    ...mapGetters(['getIsSidebarOpen'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/header/burger/Burger.vue